// store/useUserStore.js
import { create } from "zustand";

const useUserStore = create((set) => ({
  Tuser: 0,
  Tusersize: "",
  users: [],
  setusers: (val) => set({users: val}),
  setTuser: (val) => set({ Tuser: val }),
  setTusersize: (val) => set({ Tusersize: val }),
}));

export default useUserStore;
